import { Injectable } from "@angular/core";
import { IID_FEASABILITY_CONNECTION_REQUEST } from "@common/interfaces/interfaceData";
import { ID } from "@common/interfaces/id";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceName } from "@common/interfaces/issueTypeInterface";
import { PersistedStoreConfig } from "@persistence/persisted-store-config";
import { InterfaceDataStore } from "../interfaceDataRegistry";

export interface IIDConnectionRequestState extends EntityState<IID_FEASABILITY_CONNECTION_REQUEST, ID> {}

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_FEASABILITY_CONNECTION_REQUEST , realtimeEntity: 'IID_FeasabilityConnectionRequest'})
@InterfaceDataStore(InterfaceName.IID_FEASABILITY_CONNECTION_REQUEST)
export class IIDConnectionRequestStore extends EntityStore<IIDConnectionRequestState> {
  constructor() {
    super([]);
  }
}
